exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-header[data-v-a5cccc44]{background-color:#fff}@media screen and (min-width:768px){.site-header--fixed[data-v-a5cccc44]{position:fixed;width:100%;top:0;z-index:1000;-webkit-transition:all .2s ease;-moz-transition:all .2s ease;-o-transition:all .2s ease;transition:all .2s ease}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a5cccc44","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//node_modules//bootstrap-sass//assets//stylesheets//bootstrap//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/grad-images/site-header/components/SiteHeader.vue
// module id = 1773
// module chunks = 26